module.exports = __webpack_public_path__ + "img/dingdan_nor.7886a6b3.svg";